/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { SvgIcon, SvgIconProps } from '@material-ui/core';

const MsTeamsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} height="24" viewBox="0 0 24 24" width="24">
    <path d="m19.19 8.77q-.46 0-.86-.17-.39-.17-.69-.47-.3-.3-.47-.69-.17-.4-.17-.86 0-.45.17-.85.17-.4.47-.69.3-.3.69-.47.4-.18.86-.17.45-.01.85.17.4.17.7.47.29.29.47.69.17.4.17.85 0 .46-.17.86-.17.39-.47.69-.3.3-.7.47-.4.17-.85.17m0-3.12q-.39 0-.69.27-.25.27-.25.66 0 .39.25.67.3.25.69.25.39 0 .66-.25.28-.25.28-.67 0-.39-.28-.66-.27-.27-.66-.27m2.81 4.68v4.67q0 .63-.24 1.2-.26.57-.67.99-.43.43-1 .67-.59.25-1.21.25-.38 0-.76-.11-.39-.07-.71-.25-.24.79-.71 1.44-.47.65-1.1 1.11-.63.46-1.39.7-.76.27-1.58.27-.96 0-1.81-.33-.82-.33-1.5-.94-.66-.57-1.09-1.36-.44-.8-.57-1.74h-4.83q-.33 0-.59-.25-.24-.24-.24-.58v-8.34q0-.34.24-.59.26-.24.59-.24h7.17q-.29-.6-.29-1.25 0-.61.23-1.15.22-.5.62-.92.4-.39.94-.62.5-.23 1.12-.23.61 0 1.14.23.53.23.93.62.4.42.62.92.23.54.23 1.15 0 .6-.23 1.14-.22.53-.62.92-.4.4-.93.63-.53.23-1.14.23-.15 0-.31-.02-.15-.02-.31-.05v.9h9.06q.39 0 .67.27.27.27.27.66m-9.37-6.33q-.35 0-.63.11-.33.13-.56.36-.22.23-.35.53-.13.31-.13.65 0 .35.13.65.13.3.35.53.23.22.56.36.28.13.63.13.34 0 .64-.13.3-.14.53-.36.23-.23.36-.53.14-.3.14-.65 0-.34-.14-.65-.13-.3-.36-.53-.23-.23-.53-.36-.3-.11-.64-.11m-4.85 6.18h1.88v-1.56h-5.32v1.56h1.88v5h1.56m8.6 1.09v-5.62h-4.38v5.42q0 .34-.24.58-.26.25-.59.25h-2.25q.13.67.47 1.25.34.57.82.99.48.41 1.1.65.61.21 1.32.21.77 0 1.45-.27.68-.3 1.2-.81.51-.51.8-1.19.3-.68.3-1.46m4.37-1.27v-4.35h-3.12v5.71q.25.25.57.38.3.12.68.12.39 0 .73-.15.34-.15.59-.4.26-.25.4-.6.15-.34.15-.71z" />
  </SvgIcon>
);

export default MsTeamsIcon;
